import AdminHttpService from "admin/common/adminHttpService";
import ThrowsValidationError from "common/http/throwsValidationError";
import { Trader } from "features/settings/traders/trader";

class TraderService extends AdminHttpService {
    async listTraders(merchantId: string): Promise<Trader[]> {        
        const response = await this.getClient().get<Trader[]>(`/settings/v1/merchants/${merchantId}/traders`);
        return response.data;
    }
    
    @ThrowsValidationError()
    async updateTraderNonPro(merchantId: string, trader: Trader): Promise<any> {
        await this.getClient().put(
            `/settings/v1/merchants/${merchantId}/traders/${trader.userId}/non-pro`,
            { value: trader.isNonProUser}
        );
    }

    @ThrowsValidationError()
    async updateTrader(merchantId: string, trader: Trader): Promise<any> {
        await this.getClient(merchantId).put(
          `/settings/v1/traders/${trader.userId}`,
          trader
        );
    }

    @ThrowsValidationError()
    async createTrader(merchantId: string, trader: Trader): Promise<Trader> {    
        const response = await this.getClient(merchantId).post<Trader>("/settings/v1/traders", trader);
        return response.data;
    }
  
    @ThrowsValidationError()
    async deleteTrader(merchantId: string, trader: Trader): Promise<any> {
        await this.getClient(merchantId).delete(`/settings/v1/traders/${trader.userId}`);
    }
}

const traderService = new TraderService();
export default traderService;